import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle } from '../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../theme';

const { spacing, colors, fontSize, radius, fonts } = redesignTheme;

export const useHelpModalConfirmationStyles = makeStyles((theme: Theme) => ({
  helpConfirmContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: spacing.md,
    position: 'relative',
    width: '100%',
  },
  helpConfirmCloseButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: 0,
    color: colors.textBody,
    '& svg': {
      fontSize: 24,
    },
  },
  helpConfirmIconWrapper: {
    width: 64,
    height: 64,
    borderRadius: radius.md,
    backgroundColor: 'rgba(0, 10, 141, 0.04)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  helpConfirmTextGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.xs,
    width: '100%',
  },
  helpConfirmTitle: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.xl,
    lineHeight: '28px',
    color: colors.primary,
    margin: 0,
  },
  helpConfirmDescription: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    lineHeight: 'normal',
    color: colors.textBody,
    margin: 0,
    maxWidth: 400,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  helpConfirmCta: {
    ...primaryButtonStyle,
    width: '100%',
    color: '#fafafa',
    lineHeight: '20px',
    gap: 10,
  },
  helpConfirmCtaIcon: {
    fontSize: 16,
  },
}));
